<template>
  <v-container fluid>
    <v-row
      class="d-flex justify-center align-stretch"
    >
        <SectionBtnCard
            v-for="(menuItem, i) in menuItems"
            :key="i"
            :to="`/${menuItem.link}`"
            :icon="menuItem.icon"
            :target="menuItem.target"
        >
          {{ menuItem.text }}
        </SectionBtnCard>
    </v-row>
    <v-subheader
        class="justify-center"
        v-if="hasAnyAbility(
              $constants.ABILITY.SERVICE_TAIL_NUMBERS_REPORT,
              $constants.ABILITY.SERVICE_LOGS_TRACKING_30_M,
              $constants.ABILITY.SERVICE_LOGS_TRACKING_1_H,
              $constants.ABILITY.SERVICE_LOGS_TRACKING_1_D
          )"
    >
      services
    </v-subheader>
    <v-row
        class="d-flex justify-center align-stretch"
    >
      <SectionBtnCard
          v-for="(menuItem, i) in menuServices"
          :key="i"
          :to="`/${menuItem.link}`"
          :icon="menuItem.icon"
          :target="menuItem.target"
      >
        {{ menuItem.text }}
      </SectionBtnCard>
    </v-row>
  </v-container>
</template>
<script>

import { mapGetters } from 'vuex';
import SectionBtnCard from '../components/SectionBtnCard.vue';

export default {
  name: 'Root',
  components: { SectionBtnCard },

  computed: {
    ...mapGetters({
      menuItems: 'menu/filteredMenuItems',
      menuServices: 'menu/filteredMenuServices',
    }),
  },
};
</script>
